// FLAMEL 2026-08-16 — los titulares del modal usan <h2>, no <h1>: en la PDP competían con
// el título del producto y dejaban dos H1 en cada ficha con buscador. La clase tf-h1 se
// conserva, así que el aspecto no cambia.
/* Buscador de Tono IA — MyDollHair
 * Sección de theme (vanilla). Port de la state machine del prototipo DCLogic.
 * Flujo: upload → ready → analyzing → result (→ quickview).
 * El resultado lista los productos con stock en el tono recomendado.
 */
(function () {
  'use strict';

  var root = document.getElementById('tf-root');
  if (!root || root.dataset.tfInit) return;
  root.dataset.tfInit = '1';

  var cfg = readJSON('tf-config') || {};
  var stock = readJSON('tf-stock') || [];
  var PRODUCT_META = readJSON('tf-products') || {}; // { handle: { photo, desc } } — foto de modelo + descripción
  var BACKEND = (cfg.backendUrl || '').trim().replace(/\/+$/, '');
  if (BACKEND && !/^https?:\/\//i.test(BACKEND)) BACKEND = 'https://' + BACKEND; // sin esquema → lo tratamos como https (evita URL relativa al dominio de la tienda)
  var PLACEMENT = cfg.placement || 'home';
  var CURRENT_HANDLE = (cfg.currentHandle || '').trim(); // handle de la ficha donde vive el widget (solo PDP)
  var SHOW_ALTS = cfg.showAlternatives !== false; // muestra el tono recomendado + 2 sugerencias ("También podrían funcionarte")
  var GUARANTEE = cfg.guaranteeText || '30 días de garantía de color';
  var AI_NOTE = cfg.aiDisclaimer || "Usamos inteligencia artificial para analizar tu foto al instante. Guardamos tu foto 30 días para entrenar y mejorar el sistema, y después se borra automáticamente.";
  // Texto del consentimiento y su VERSIÓN. La versión viaja en cada análisis: el
  // backend solo guarda la foto si coincide con la lista que tiene aprobada, así que
  // un widget cacheado con el texto viejo nunca puede provocar que se guarde una foto
  // que su dueña no autorizó.
  var CONSENT_TEXT = cfg.consentText || "Acepto que mi(s) foto(s) sean analizadas por inteligencia artificial para recomendarme un tono, y que se conserven 30 días para entrenar y mejorar el sistema. Pasados los 30 días se borran automáticamente.";
  var CONSENT_VERSION = cfg.consentVersion || "2026-08-thumbs";
  var PRIVACY_URL = cfg.privacyUrl || '';
  var RESULT_DISCLAIMER = cfg.resultDisclaimer || 'Este match lo genera una inteligencia artificial y puede equivocarse.';
  // Las dos salidas del aviso legal del resultado. Si MDH vacía una, su enlace desaparece:
  // más vale un aviso con un solo enlace que un enlace roto en una pantalla legal.
  var WHATSAPP_URL = (cfg.whatsappUrl || '').trim();
  var TERMS_URL = (cfg.termsUrl || '').trim();
  var CONF_TOOLTIP = 'Es un análisis con IA: no puede ser 100% exacto, pero te decimos el tono que mejor encaja contigo.';
  var CURRENCY = cfg.currency || 'COP';
  var REF_PHOTOS = [cfg.refPhoto1, cfg.refPhoto2, cfg.refPhoto3]; // pueden venir vacías (placeholders)
  var REF_CAPTIONS = (cfg.refCaptions && cfg.refCaptions.length === 3) ? cfg.refCaptions
    : ['Pelo suelto y bien visible, ocupando buena parte de la foto', 'Con luz natural, sin filtros ni contraluz', 'De lado, con el pelo cogido para ponytails'];
  // Ejemplos EN NEGATIVO ("evita esto"): los cuatro errores que más arruinan el análisis del tono.
  // Los textos NO repiten la palabra "evita" porque el título del grupo ya la lleva.
  var BAD_PHOTOS = [cfg.refBad1, cfg.refBad2, cfg.refBad3, cfg.refBad4];
  var BAD_CAPTIONS = (cfg.refBadCaptions && cfg.refBadCaptions.length === 4) ? cfg.refBadCaptions
    : ['Fotos con el sol directo: el pelo se ve de otro tono', 'Fotos con más personas o en las que salgas muy lejos', 'Fotos oscuras, con flash o frente a un espejo', 'Fotos con filtros: cambian el color de tu pelo'];
  var PRODUCTS_LIMIT = 3;
  var MAX_PHOTOS = 3;
  // Modo entrenamiento: activa el botón de feedback (bien/mal) SOLO con ?tf_train=1 en la URL.
  // Invisible para las clientas reales. Es PEGAJOSO: se recuerda en localStorage toda la sesión, porque
  // la vista previa de Shopify borra los parámetros extra de la URL al navegar (perdía tf_train=1).
  // Se apaga con ?tf_train=0.
  var TRAIN = /[?&]tf_train=1(?:&|$)/.test(window.location.search || '');
  try {
    if (/[?&]tf_train=0(?:&|$)/.test(window.location.search || '')) { localStorage.removeItem('tf_train'); TRAIN = false; }
    else if (TRAIN) { localStorage.setItem('tf_train', '1'); }
    else if (localStorage.getItem('tf_train') === '1') { TRAIN = true; }
  } catch (e) { /* incógnito / storage bloqueado: se mantiene el comportamiento por URL */ }
  // Muestra el apartado de feedback SIN activar el modo entrenamiento completo (tonos/stock siguen realistas).
  // Se enciende con ?tf_train=1 (TRAIN) o con el ajuste del tema "Mostrar feedback" (cfg.showFeedback).
  var SHOW_FEEDBACK = TRAIN || cfg.showFeedback === true;
  // PUERTA de correo. Cuando está encendida, el análisis NO se lanza hasta que la clienta deja
  // nombre + correo + consentimiento: alimenta el flow de Klaviyo y, de paso, deja de gastar
  // llamadas a la IA en sesiones que no van a dejar ni el correo.
  // Apagada, el flujo es el de siempre (preparar → analizar → resultado) y no se pide nada.
  // Es el interruptor de emergencia: si la puerta hunde la conversión, se apaga desde el
  // personalizador sin tocar código.
  var SHOW_EMAIL = cfg.showEmailCapture === true;
  var GATE_CONSENT_TEXT = cfg.gateConsentText || 'Acepto que My Doll Hair use mi nombre y correo para enviarme el resultado de mi análisis y comunicaciones sobre productos y promociones. Puedo darme de baja cuando quiera.';
  // Valoración de la experiencia (👎/👍/😍). Encendida por defecto: no pide ningún dato y es
  // la única lectura directa de si a la clienta le gustó lo que le recomendamos.
  var SHOW_RATING = cfg.showClientRating !== false;

  // Formatea el precio (Shopify lo da en céntimos). Bonito y con separador de miles.
  function formatPrice(cents, fallback) {
    if (cents == null || isNaN(cents)) return fallback || '';
    var amount = cents / 100;
    var decimals = amount % 1 === 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat('es-CO', { style: 'currency', currency: CURRENCY, minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(amount);
    } catch (e) {
      return '$' + amount.toLocaleString();
    }
  }

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function absUrl(u) { try { return new URL(u, window.location.origin).href; } catch (e) { return u; } }
  function stripHtml(h) { var d = document.createElement('div'); d.innerHTML = h || ''; return (d.textContent || '').replace(/\s+/g, ' ').trim(); }

  /* ---------- Tonos: normalización + hex (igual que tone-variant-map.json) ---------- */
  var HEX = {
    'negro': '#1a1413', 'castaño oscuro': '#3b2a22', 'castaño medio': '#5a3f2e', 'castaño chocolate': '#4a2f22',
    'castaño miel': '#7d5635', 'castaño dorado': '#8a6234', 'castaño claro': '#9c7550', 'mix toffe': '#836046',
    'mix caramelo': '#9a6e44', 'castaño cobrizo': '#6e3b25', 'caoba': '#5e2a26', 'mix capuccino': '#8a6a4f',
    'rubio cobrizo': '#a9683c', 'cobrizo': '#b05a2a', 'borgoña': '#5a1f2a', 'rojo intenso': '#8a2420',
    'rubio oscuro cenizo': '#8d7656', 'rubio beige': '#c3a878', 'mix avellana': '#9b7a52', 'mix latte': '#b59a6f',
    'rubio dorado': '#c79a52', 'rubio vainilla': '#d8c290', 'rubio cenizo': '#b8a888', 'mix expresso': '#2e211c',
    'rubio perlado': '#d9c9a8', 'rubio arena': '#caa46a', 'rubio claro': '#d3b97e', 'rubio miel': '#bf914c'
  };
  function titleCase(s) {
    return s.replace(/\w[^\s]*/g, function (w) {
      var low = ['de', 'y']; return low.indexOf(w) >= 0 ? w : w.charAt(0).toUpperCase() + w.slice(1);
    });
  }
  function normTone(c) {
    var s = String(c || '');
    s = s.replace(/colecci[oó]n\s*olimpo/gi, '');
    s = s.replace(/\(olimpo\)/gi, '');
    s = s.replace(/\bolimpo\b/gi, '');
    s = s.replace(/\bgalactico\b/gi, '');
    s = s.replace(/hair\s*bar/gi, '');
    s = s.replace(/hairbar/gi, '');
    s = s.replace(/\(ext[^)]*\)/gi, '');
    s = s.replace(/-/g, ' ');
    s = s.replace(/[⚡✨]/g, '');
    s = s.replace(/\s+/g, ' ').trim().toLowerCase();
    return s;
  }
  function isPlaceholder(c) {
    var cl = String(c || '').toLowerCase();
    return ['⚡', 'descubre', 'selecciona tu tono', 'elige tu', 'encuentra tu', 'elige tu shade']
      .some(function (m) { return cl.indexOf(m) >= 0; });
  }

  /* ---------- Construir los 28 tonos + enriquecerlos con stock vivo ---------- */
  // HEX es la lista canónica del recomendador. Se inicializan TODOS sus tonos aunque hoy
  // no tengan stock: la IA debe resolver el match real primero; inventario se aplica después.
  var tones = {}; // key -> { key, displayName, hex, variants:[...] }
  Object.keys(HEX).forEach(function (key) {
    tones[key] = { key: key, displayName: titleCase(key), hex: HEX[key], variants: [] };
  });
  stock.forEach(function (v) {
    if (isPlaceholder(v.color)) return;
    var key = normTone(v.color);
    if (!HEX[key]) return; // tono fuera del sistema mapeado
    tones[key].variants.push(v);
  });
  function availableVariants(t) {
    return (t.variants || []).filter(function (v) { return v.available && (v.qty == null || v.qty > 0); })
      .sort(function (a, b) { return (b.qty || 0) - (a.qty || 0); });
  }
  // La inferencia SIEMPRE compara contra los 28 tonos. El stock nunca modifica esta lista.
  var candidateTones = Object.keys(HEX).map(function (k) { return tones[k]; });
  // Las referencias visuales pertenecen al manifiesto canónico del backend; el theme solo
  // declara la taxonomía y nunca vuelve a codificar URLs o números de referencia.
  var candidates = candidateTones.map(function (t) { return { tone: t.displayName, hex: t.hex, key: t.key }; });
  var toneByName = {};
  Object.keys(tones).forEach(function (k) { toneByName[tones[k].displayName] = tones[k]; });

  /* ---------- Estado ---------- */
  // `highlights` (visos) y `toneVibe` (matiz) ya no se preguntan: la pantalla «Afina tu match»
  // dejó de mostrarlas. Los campos se conservan vacíos a propósito para no cambiar la forma del
  // payload del backend ni la de los eventos de medición.
  var state = {
    step: 'howto', photos: [], consent: false, goal: '', highlights: '', toneVibe: '', productType: '',
    progress: 0, statusText: '', phase: '', rec: null, alternatives: [], shownTone: null,
    quickProduct: null, email: '', error: '',
    // Puerta: lo que la clienta deja antes de que se lance la IA.
    gateName: '', gateConsent: false, emailCaptured: false, leadId: '',
    prepared: null,   // { rgb, visualFeatures, b64s } — preparación lista para el backend
    analysisId: '',   // lo devuelve /analyze; es la clave que une valoración ↔ análisis ↔ pedido
    pdpSelected: '', // tono ya marcado en el selector de la ficha (evita repetir el click al cerrar)
    rating: '', ratingSent: '', // valoración de la clienta (👎/👍/😍)
    feedbackVerdict: '', feedbackSent: false, // solo modo entrenamiento
    howtoSeen: false // solo para distinguir la primera visita a los consejos de las siguientes
  };
  // Los cuatro estados de siempre, repartidos entre los dos tramos de la barra. Los dos
  // primeros describen lo que pasa DE VERDAD en el navegador mientras se prepara la foto;
  // los dos últimos, la llamada a la IA. La barra no dice que analiza cuando no analiza.
  var STATUSES_PREP = ['Leyendo tu foto…', 'Detectando tu cabello…'];
  var STATUSES_AI = ['Comparando con nuestros tonos…', 'Calculando tu match ideal…'];
  var timers = {};
  var sessionId = 0; // invalida análisis en curso si se cierra/reinicia el widget
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  // El correo ya dado se recuerda entre visitas: pedirlo dos veces es fricción sin retorno,
  // y con la puerta obligatoria además dejaría fuera a quien ya pagó el peaje.
  var LEAD_KEY = 'tf_lead';
  function readStoredLead() {
    try { return JSON.parse(localStorage.getItem(LEAD_KEY) || 'null'); } catch (e) { return null; }
  }
  function storeLead(email, name) {
    try { localStorage.setItem(LEAD_KEY, JSON.stringify({ email: email, name: name || '' })); } catch (e) { /* incógnito */ }
  }
  (function restoreLead() {
    // ?tf_reset=1 olvida el correo recordado. Existe por QA: como la puerta NO se repite
    // a quien ya la cruzó, en cuanto la pruebas una vez deja de aparecer y parece que se
    // ha roto. Sin esto, la única salida era una ventana de incógnito. Misma convención
    // que ?tf_train=1, y para una clienta real no cambia nada.
    if (/[?&]tf_reset=1(?:&|$)/.test(window.location.search || '')) {
      try { localStorage.removeItem(LEAD_KEY); } catch (e) { /* incógnito */ }
      return;
    }
    var saved = readStoredLead();
    if (saved && saved.email && EMAIL_RE.test(saved.email)) {
      state.email = saved.email; state.gateName = saved.name || ''; state.emailCaptured = true;
    }
  })();
  // El id de sesión que escribe el puente de medición. Une el análisis del backend con el
  // recorrido de esa misma clienta en GA4.
  function tfSessionId() {
    try { return sessionStorage.getItem('flamel_tf_session_id') || ''; } catch (e) { return ''; }
  }
  function primaryUrl() { return state.photos[0] ? state.photos[0].url : ''; }

  /* ---------- Medición (dataLayer → GTM → GA4) ---------- */
  function dl(event, data) {
    window.dataLayer = window.dataLayer || [];
    var p = { event: event, placement: PLACEMENT };
    if (data) for (var k in data) p[k] = data[k];
    window.dataLayer.push(p);
  }

  /* ---------- Imagen: color dominante + base64 ---------- */
  function loadImage(url) {
    return new Promise(function (res, rej) { var i = new Image(); i.onload = function () { res(i); }; i.onerror = rej; i.src = url; });
  }
  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), h, s, l = (mx + mn) / 2;
    if (mx === mn) { h = s = 0; } else {
      var d = mx - mn; s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn);
      switch (mx) { case r: h = (g - b) / d + (g < b ? 6 : 0); break; case g: h = (b - r) / d + 2; break; default: h = (r - g) / d + 4; }
      h /= 6;
    }
    return [h * 360, s, l];
  }
  function roundFeature(n, digits) {
    var p = Math.pow(10, digits == null ? 3 : digits);
    return Math.round((Number(n) || 0) * p) / p;
  }
  function percentile(values, q) {
    if (!values.length) return 0;
    var sorted = values.slice().sort(function (a, b) { return a - b; });
    var pos = (sorted.length - 1) * q;
    var lo = Math.floor(pos), hi = Math.ceil(pos);
    if (lo === hi) return sorted[lo];
    return sorted[lo] + (sorted[hi] - sorted[lo]) * (pos - lo);
  }
  function rgbPercentile(pixels, q) {
    return [0, 1, 2].map(function (channel) {
      return Math.round(percentile(pixels.map(function (p) { return p[channel]; }), q));
    });
  }
  function rgbMean(pixels) {
    var sum = [0, 0, 0];
    pixels.forEach(function (p) { sum[0] += p[0]; sum[1] += p[1]; sum[2] += p[2]; });
    return sum.map(function (n) { return Math.round(n / Math.max(1, pixels.length)); });
  }

  /**
   * Extrae una muestra RGB compatible con el backend y, además, estadísticas compactas.
   * No pretende segmentar cabello: deja evidencia observable para auditar luz, contraste y
   * consistencia entre fotos sin enviar miles de píxeles ni tomar una media frágil.
   */
  function extractColor(url, photoIndex) {
    return loadImage(url).then(function (img) {
      var sourceW = img.naturalWidth || img.width, sourceH = img.naturalHeight || img.height;
      var scale = Math.min(1, 160 / Math.max(sourceW, sourceH));
      var W = Math.max(1, Math.round(sourceW * scale)), H = Math.max(1, Math.round(sourceH * scale));
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, W, H);
      var d = ctx.getImageData(0, 0, W, H).data;
      var all = [], admissible = [], hairLike = [], darkClipped = 0, brightClipped = 0;
      for (var i = 0; i < d.length; i += 4) {
        if (d[i + 3] < 200) continue;
        var r = d[i], g = d[i + 1], b = d[i + 2], hsl = rgbToHsl(r, g, b), hh = hsl[0], s = hsl[1], l = hsl[2];
        // Luminancia percibida separada de la luminosidad HSL: evita llamar "luminancia"
        // a una señal distinta cuando estas métricas se consuman en evaluaciones futuras.
        var luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        var pixel = [r, g, b, hh, s, l, luminance];
        all.push(pixel);
        if (luminance <= 0.03) darkClipped++;
        if (luminance >= 0.97) brightClipped++;
        // Conserva rubios claros y cenizos, que el filtro anterior (l < .62) descartaba.
        if (l >= 0.04 && l <= 0.92 && s <= 0.88) {
          admissible.push(pixel);
          // Cabello natural/teñido de la gama: baja saturación o hue rojo→amarillo.
          if (s <= 0.35 || hh <= 85 || hh >= 315) hairLike.push(pixel);
        }
      }
      if (!all.length) throw new Error('imagen sin píxeles opacos');

      var minimum = Math.max(48, Math.floor(all.length * 0.04));
      var picks = hairLike.length >= minimum ? hairLike : (admissible.length >= minimum ? admissible : all);
      var strategy = hairLike.length >= minimum ? 'hair_hue_or_low_saturation' : (admissible.length >= minimum ? 'exposure_trim' : 'all_opaque');
      picks.sort(function (a, b) { return a[6] - b[6]; });
      // Recorte robusto de extremos de exposición antes de calcular medianas.
      var lo = Math.floor(picks.length * 0.08), hi = Math.ceil(picks.length * 0.92);
      var seg = picks.slice(lo, hi).length ? picks.slice(lo, hi) : picks;
      var sampledRgb = rgbPercentile(seg, 0.5);
      var lights = seg.map(function (p) { return p[6]; });
      var saturations = seg.map(function (p) { return p[4]; });
      var neutral = 0, warm = 0, cool = 0;
      seg.forEach(function (p) {
        if (p[4] < 0.12) neutral++;
        else if (p[3] <= 85 || p[3] >= 330) warm++;
        else if (p[3] >= 170 && p[3] <= 300) cool++;
      });
      var denom = Math.max(1, seg.length);

      return {
        sampledRgb: sampledRgb,
        visualFeatures: {
          photoIndex: photoIndex || 0,
          source: { width: sourceW, height: sourceH },
          sample: { width: W, height: H, opaquePixels: all.length, selectedPixels: seg.length, selectionRatio: roundFeature(seg.length / all.length), strategy: strategy },
          rgb: { median: sampledRgb, mean: rgbMean(seg), p10: rgbPercentile(seg, 0.1), p90: rgbPercentile(seg, 0.9) },
          luminance: { p10: roundFeature(percentile(lights, 0.1)), median: roundFeature(percentile(lights, 0.5)), p90: roundFeature(percentile(lights, 0.9)), contrast: roundFeature(percentile(lights, 0.9) - percentile(lights, 0.1)) },
          saturation: { median: roundFeature(percentile(saturations, 0.5)), p90: roundFeature(percentile(saturations, 0.9)) },
          hueRatios: { warm: roundFeature(warm / denom), cool: roundFeature(cool / denom), lowSaturation: roundFeature(neutral / denom) },
          clipping: { dark: roundFeature(darkClipped / all.length), bright: roundFeature(brightClipped / all.length) }
        }
      };
    });
  }
  function aggregateVisualFeatures(photoAnalyses) {
    var rgbs = photoAnalyses.map(function (p) { return p.sampledRgb; });
    var sampledRgb = [0, 1, 2].map(function (channel) {
      return Math.round(percentile(rgbs.map(function (rgb) { return rgb[channel]; }), 0.5));
    });
    var spreads = [0, 1, 2].map(function (channel) {
      var values = rgbs.map(function (rgb) { return rgb[channel]; });
      return Math.round(percentile(values, 0.9) - percentile(values, 0.1));
    });
    return {
      version: 1,
      photoCount: photoAnalyses.length,
      sampledRgb: sampledRgb,
      consistency: { rgbSpreadP10P90: spreads },
      photos: photoAnalyses.map(function (p) { return p.visualFeatures; })
    };
  }
  function toBase64(url) {
    return loadImage(url).then(function (i) {
      var m = 512 / Math.max(i.width, i.height), sc = Math.min(1, m);
      var w = Math.round(i.width * sc), h = Math.round(i.height * sc);
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      c.getContext('2d').drawImage(i, 0, 0, w, h);
      return c.toDataURL('image/jpeg', 0.82).split(',')[1];
    });
  }
  function toBase64All() { return Promise.all(state.photos.map(function (p) { return toBase64(p.url); })); }

  /* ---------- Análisis, en dos tramos ---------- */
  // La barra ya no es un solo recorrido. El tramo 1 es trabajo REAL del navegador (leer el
  // color y codificar las fotos) y no cuesta ni un token; el tramo 2 es la llamada a la IA.
  // La puerta del correo se cuela entre los dos: así solo se paga IA por quien la cruza.
  var GATE_AT = 90;       // dónde se para la barra a esperar el correo
  var MIN_PREP_MS = 2500; // suelo del tramo 1: en un móvil rápido, si no, parpadearía

  function startProgress(target, statuses) {
    // Curva suave: se acerca asintóticamente al objetivo (sin saltos aleatorios).
    // No toca state.progress al arrancar — lo fija quien llama, porque el tramo 2
    // continúa desde donde se quedó el tramo 1 en vez de volver a cero.
    timers.prog = setInterval(function () {
      state.progress = Math.min(target, state.progress + (target - state.progress) * 0.06 + 0.5);
      if (timers.barFill) timers.barFill.style.width = state.progress.toFixed(1) + '%';
    }, 90);
    var si = 0;
    timers.stat = setInterval(function () {
      si = (si + 1) % statuses.length;
      state.statusText = statuses[si];
      if (timers.statusEl) timers.statusEl.textContent = statuses[si];
    }, 1400);
  }

  /** ¿Hay que pedirle el correo? No, si la puerta está apagada o si ya nos lo dio. */
  function gateNeeded() { return SHOW_EMAIL && !state.emailCaptured; }

  /** TRAMO 1 — preparación local. Cero llamadas a la IA: aquí no se gasta nada. */
  function prepare() {
    if (!state.consent || !state.photos.length) return;
    var mySession = ++sessionId; // token de esta ejecución
    setState({ step: 'analyzing', phase: 'prep', progress: 0, error: '', statusText: STATUSES_PREP[0] });
    dl('tf_prepare', { goal: state.goal, tone_vibe: state.toneVibe, photos: state.photos.length });
    startProgress(GATE_AT, STATUSES_PREP);
    var startedAt = Date.now();

    var featureJobs = state.photos.map(function (photo, index) { return extractColor(photo.url, index); });
    Promise.all([Promise.all(featureJobs), toBase64All()]).then(function (out) {
      if (mySession !== sessionId) return;
      var visualFeatures = aggregateVisualFeatures(out[0]);
      // Espera hasta cumplir el suelo: pasar de 0 a la puerta en 300 ms se lee como un
      // salto raro, no como «ya está listo».
      var wait = Math.max(0, MIN_PREP_MS - (Date.now() - startedAt));
      setTimeout(function () {
        if (mySession !== sessionId) return;
        state.prepared = { rgb: visualFeatures.sampledRgb, visualFeatures: visualFeatures, b64s: out[1] };
        stopTimers();
        state.progress = GATE_AT;
        if (timers.barFill) timers.barFill.style.width = GATE_AT + '%';
        // Sin puerta (apagada, o el correo ya dado) los dos tramos se funden en uno solo.
        if (!gateNeeded()) { runAnalysis(); return; }
        setState({ step: 'gate' });
        dl('tf_gate_view', {});
      }, wait);
    }).catch(function () {
      if (mySession !== sessionId) return;
      stopTimers();
      setState({ step: 'ready', phase: '', error: 'No pudimos leer bien esa foto. Prueba con una con buena luz natural y tu pelo visible.' });
    });
  }

  /** TRAMO 2 — la llamada real a la IA. Solo se llega aquí con el correo ya capturado. */
  function runAnalysis() {
    var prep = state.prepared;
    if (!prep) { prepare(); return; } // defensa: sin preparación no hay nada que analizar
    var mySession = ++sessionId;
    setState({ step: 'analyzing', phase: 'ai', progress: GATE_AT, error: '', statusText: STATUSES_AI[0] });
    dl('tf_analyze', { goal: state.goal, tone_vibe: state.toneVibe, photos: state.photos.length, visual_features_version: prep.visualFeatures && prep.visualFeatures.version });
    // Objetivo 99 y no 100: el 100 se pone de golpe al llegar el resultado, y es esa
    // última sacudida la que hace que se sienta terminado.
    startProgress(99, STATUSES_AI);

    callBackend(prep.rgb, prep.b64s, prep.visualFeatures).then(function (result) {
      if (mySession !== sessionId) return; // se cerró/reinició: ignora resultado obsoleto
      stopTimers();
      if (timers.barFill) timers.barFill.style.width = '100%';
      state.progress = 100;
      if (result && result.analysis_id) state.analysisId = result.analysis_id;
      // La IA detectó que la foto no muestra cabello → pedir otra foto con instrucciones.
      // El correo ya está capturado, pero NO se dispara el evento de Klaviyo: un flow
      // lanzado sin tono mandaría un correo vacío.
      if (result && result.notHair) {
        setTimeout(function () { if (mySession === sessionId) { setState({ step: 'invalid', phase: '', error: '' }); dl('tf_invalid_image', {}); } }, 360);
        return;
      }
      if (!result || !result.recommended || !result.recommended.tone) {
        var invalidResult = new Error('respuesta sin recomendación');
        invalidResult.code = 'backend_invalid_result';
        throw invalidResult;
      }
      // La IA ya decidió entre los 28 tonos; recién ahora se aplica la disponibilidad comercial.
      var enforced = enforceStock(result);
      enforced.alternatives = enforced.alternatives || [];
      setTimeout(function () {
        if (mySession !== sessionId) return;
        setState({ step: 'result', phase: '', rec: enforced.recommended, alternatives: enforced.alternatives, shownTone: enforced.recommended.tone });
        dl('tf_result', {
          recommended_tone: enforced.recommended.tone,
          matched_tone: enforced.matchedTone || enforced.recommended.tone,
          stock_substitution: !!enforced.stockSubstitution,
          stock_unavailable: !!enforced.stockUnavailable,
          confidence: enforced.recommended.confidence,
          fallback: !!enforced.fallback,
          tone_vibe: state.toneVibe,
          available_products: availableForTone(enforced.recommended.tone).length
        });
        // Ahora sí hay tono: se dispara la métrica que arranca el flow del correo.
        postLeadResult(enforced.recommended, enforced.alternatives);
      }, 360);
    }).catch(function (err) {
      if (mySession !== sessionId) return;
      stopTimers();
      state.prepared = null;
      dl('tf_analysis_error', {
        reason: err && err.code ? err.code : 'backend_unavailable',
        http_status: err && err.status ? err.status : 0,
        tone_vibe: state.toneVibe
      });
      setState({ step: 'ready', phase: '', error: 'No pudimos conectar con el análisis de IA. Tus fotos siguen aquí: pulsa “Analizar mi color” para reintentar.' });
    });
  }

  function callBackend(rgb, b64s, visualFeatures) {
    if (!BACKEND) {
      var missing = new Error('sin backend'); missing.code = 'backend_not_configured';
      return Promise.reject(missing);
    }
    var ctrl = new AbortController(); timers.abort = ctrl;
    return fetch(BACKEND + '/analyze', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: ctrl.signal,
      body: JSON.stringify({
        images: b64s, sampledRgb: rgb, visualFeatures: visualFeatures,
        goal: state.goal, highlights: state.highlights, toneVibe: state.toneVibe,
        candidates: candidates.map(function (c) { return { tone: c.tone, hex: c.hex }; }),
        // La MISMA copia de 512px que ya va en images: no se codifica dos veces.
        // El backend la guarda solo si CONSENT_VERSION está en su lista aprobada.
        thumbs: b64s,
        consent_version: CONSENT_VERSION,
        // La escribe el bridge de medición en sessionStorage. Permite cruzar el
        // análisis del backend con el recorrido de esa misma clienta en GA4.
        tf_session_id: tfSessionId(),
        // El backend no puede deducirla: la petición es cross-origin y le llega un
        // referer sin path, así que todo le parecía la home. Se la decimos.
        placement: PLACEMENT
      })
    }).then(function (r) {
      if (!r.ok) {
        var httpError = new Error('http ' + r.status);
        httpError.code = 'backend_http_error'; httpError.status = r.status;
        throw httpError;
      }
      return r.json().catch(function () {
        var jsonError = new Error('respuesta inválida'); jsonError.code = 'backend_invalid_json';
        throw jsonError;
      });
    });
  }
  // Capa C: garantiza que el tono recomendado tenga stock; si no, degrada a alternativa válida.
  var SUBSTITUTE_DESC = 'El tono que detectamos como tu match está agotado ahora mismo; este es el más parecido que sí tenemos disponible. ✨';
  function enforceStock(result) {
    result = result || {};
    var rec = result.recommended;
    if (!rec || !rec.tone) return result; // runAnalysis lo convierte en error visible
    // Conserva la decisión del modelo separada de la sustitución comercial. Así GA4 puede
    // medir el match real aunque el producto final cambie por inventario.
    result.matchedTone = rec.tone;
    result.stockSubstitution = false;
    result.stockUnavailable = false;
    if (!availableForTone(rec.tone).length) {
      var alt = (result.alternatives || []).find(function (a) { return availableForTone(a.tone).length; });
      if (alt) { rec = { tone: alt.tone, hex: alt.hex, confidence: Math.min(rec.confidence || 90, 88), description: SUBSTITUTE_DESC }; result.stockSubstitution = true; }
      // Si tampoco hay alternativa propuesta por la IA, conservamos el match real
      // aunque esté agotado. Elegir el primer tono con stock fabricaría una recomendación.
      else result.stockUnavailable = true;
    }
    result.recommended = rec;
    result.alternatives = (result.alternatives || []).filter(function (a) { return a.tone !== rec.tone && availableForTone(a.tone).length; }).slice(0, 2);
    return result;
  }
  function availableForTone(name) { var t = toneByName[name]; return t ? availableVariants(t) : []; }
  // Foto real de la mecha para un tono: la imagen de variante (alt "#color_<Valor>") de la primera
  // variante disponible que la tenga. Devuelve '' si el tono está agotado o no tiene foto, y ahí
  // quien llame debe caer al círculo de color hex.
  function toneSwatchPhoto(name) {
    var found = availableForTone(name).filter(function (v) { return v.image; })[0];
    return found ? found.image : '';
  }

  /* ---------- Integración con la ficha de producto (PDP) ---------- */
  // En la PDP el buscador se abre desde el botón de product-info.liquid. Si el tono recomendado existe en
  // ESTE producto, lo marcamos directamente en el selector de tonos para que solo quede añadir al carrito.
  function pdpVariantForTone(toneName) {
    if (!CURRENT_HANDLE) return null;
    var list = availableForTone(toneName);
    for (var i = 0; i < list.length; i++) { if (list[i].handle === CURRENT_HANDLE) return list[i]; }
    return null;
  }
  // Comparación tolerante: el value del radio es el nombre exacto de la opción, pero puede traer
  // acentos/mayúsculas distintas o prefijos de colección ("Colección Olimpo - Castaño Miel").
  function normValue(s) {
    return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  // El selector principal de la ficha. Se descarta el que vive dentro de la barra fija de compra y el de la
  // compra rápida: son copias del mismo picker y marcarlas no actualiza el formulario visible.
  function pdpPicker() {
    var all = document.querySelectorAll('.variant-picker');
    for (var i = 0; i < all.length; i++) {
      if (all[i].closest && all[i].closest('product-sticky-add-to-cart, product-quick-buy, quick-buy')) continue;
      return all[i];
    }
    return null;
  }
  function selectToneOnPdp(toneName) {
    var v = pdpVariantForTone(toneName);
    if (!v) return false;
    var picker = pdpPicker();
    if (!picker) return false;
    // El value del radio es el id de la opción, no el nombre: emparejamos por el texto de su etiqueta
    // (<span class="sr-only">Colección Olimpo - Castaño Miel</span>), que sí coincide con v.color.
    var target = normValue(v.color);
    var labels = picker.querySelectorAll('label[for]');
    for (var i = 0; i < labels.length; i++) {
      if (normValue(labels[i].textContent) !== target) continue;
      var input = document.getElementById(labels[i].htmlFor);
      if (!input || input.disabled) return false;
      state.pdpSelected = toneName;
      if (input.checked) return true; // ya estaba seleccionado
      input.click(); // dispara el re-render de variante del tema
      dl('tf_pdp_select', { tone: toneName, variant_id: v.id, handle: CURRENT_HANDLE });
      return true;
    }
    return false;
  }

  /* ---------- Carrito + atribución (se queda en el modal) ---------- */
  function addToCart(variant, btn) {
    var rec = state.rec || {};
    if (btn && !btn.dataset.label) btn.dataset.label = btn.textContent; // guarda la etiqueta original una vez
    if (btn) { btn.disabled = true; btn.textContent = 'Añadiendo…'; btn.classList.remove('tf-btn-added'); }
    var props = {
      _tf_source: 'tone-finder', _tf_tone: rec.tone || '', _tf_confidence: String(rec.confidence || ''),
      _tf_placement: PLACEMENT, _tf_goal: state.goal || '', _tf_tone_vibe: state.toneVibe || ''
    };
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variant.id, quantity: 1, properties: props })
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw new Error((e && e.description) || 'No pudimos añadirlo a la cesta.'); });
      return r.json();
    }).then(function () {
      // Confirmación inmediata (no la bloquea la escritura de atributos de atribución).
      dl('add_to_cart', { recommended_tone: rec.tone, variant_id: variant.id, item_product: variant.product });
      dl('tf_add_to_cart', { recommended_tone: rec.tone, variant_id: variant.id });
      if (btn) { btn.disabled = false; btn.textContent = 'Añadido ✓'; btn.classList.add('tf-btn-added'); }
      refreshCartCount();
      showToast('Producto añadido a tu cesta');
      // Atribución best-effort: si falla, NO invalida la confirmación de compra.
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { tone_finder_used: 'true', tone_finder_tone: rec.tone || '' } }) }).catch(function () {});
    }).catch(function (err) {
      if (btn) { btn.disabled = false; btn.textContent = (btn.dataset.label || 'Añadir a mi carrito'); btn.classList.remove('tf-btn-added'); }
      showToast((err && err.message) ? err.message : 'No pudimos añadirlo. Inténtalo de nuevo.');
    });
  }
  // Actualiza el contador del carrito del tema (best-effort, sin recargar la página).
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var n = cart && cart.item_count;
      if (n == null) return;
      document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count], .cart-link__bubble, .header__cart-count').forEach(function (e) {
        var t = e.querySelector('span') || e; t.textContent = n;
      });
      ['cart:refresh', 'cart:updated', 'cart:build'].forEach(function (ev) { document.dispatchEvent(new CustomEvent(ev, { detail: cart, bubbles: true })); });
    }).catch(function () {});
  }
  // Toast efímero dentro del widget con enlace a la cesta.
  function showToast(msg) {
    var old = document.querySelector('.tf-toast'); if (old) old.remove();
    var link = el('a', { class: 'tf-toast-link', href: '/cart', target: '_top' }, ['Ver cesta →']);
    var t = el('div', { class: 'tf-toast' }, [el('span', null, [msg]), link]);
    document.body.appendChild(t); // position:fixed; sobrevive aunque se cierre el modal
    setTimeout(function () { t.classList.add('tf-toast-in'); }, 10);
    setTimeout(function () { t.classList.remove('tf-toast-in'); setTimeout(function () { if (t.parentNode) t.remove(); }, 300); }, 4200);
  }

  /* ---------- Correo capturado → backend → Klaviyo ---------- */
  // El correo se manda a NUESTRO backend, no a Klaviyo desde aquí. Dos motivos:
  //   1. El identify() de la librería onsite crea el perfil pero NO da consentimiento de
  //      marketing, así que el flow no entregaría el correo que le prometemos a la clienta.
  //   2. Los bloqueadores de anuncios bloquean klaviyo.js en bastantes sesiones, y con la
  //      puerta obligatoria eso significaría cobrarle el peaje y perder lo que nos dio.
  // El identify de abajo se mantiene como apoyo: le sirve a Klaviyo para enlazar su propia
  // cookie onsite con el perfil. Que falle no rompe nada.

  function klaviyoIdentify(email, name) {
    try {
      var attrs = { email: email };
      if (name) attrs.first_name = name;
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') { window.klaviyo.identify(attrs); return true; }
      // Aún no ha cargado: encolar en la cola oficial (se drena al cargar klaviyo.js).
      var k = (window.klaviyo = window.klaviyo || []);
      if (typeof k.push === 'function') { k.push(['identify', attrs]); return true; }
      var q = window._learnq;
      if (q && typeof q.push === 'function') {
        q.push(['identify', name ? { '$email': email, '$first_name': name } : { '$email': email }]);
        return true;
      }
    } catch (e) { /* noop */ }
    return false;
  }

  /** Envío best-effort al backend. `keepalive` para que sobreviva si cierra la pestaña. */
  function postJSON(endpoint, body) {
    if (!BACKEND) return Promise.reject(new Error('sin backend'));
    return fetch(BACKEND + endpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json().catch(function () { return {}; }); });
  }

  /** Al enviar la puerta. Suscribe YA, antes de saber el tono: si abandona durante el
   *  análisis, el correo tiene que ser nuestro igual. */
  function postLead() {
    postJSON('/lead', {
      email: state.email,
      name: state.gateName,
      consent_version: CONSENT_VERSION,
      tf_session_id: tfSessionId(),
      placement: PLACEMENT
    }).then(function (j) {
      if (j && j.lead_id) state.leadId = j.lead_id;
    }).catch(function () { /* el análisis sigue: la clienta no paga nuestros fallos */ });
  }

  /** Con el tono ya resuelto: dispara la métrica que arranca el flow del correo. */
  function postLeadResult(rec, alternatives) {
    if (!state.emailCaptured || !rec || !rec.tone) return;
    var products = availableForTone(rec.tone).slice(0, 6).map(function (v) {
      // MISMA foto que ve en pantalla (ver el render de .tf-prod): la de modelo, y el
      // swatch solo de respaldo. En MDH `v.image` es la imagen de VARIANTE (los `tono-*-1x1`
      // con alt "#color_…"): una foto real de la mecha, pero idéntica en los seis productos
      // del mismo tono — mandar eso al correo dejaría seis cuadraditos casi iguales donde
      // ella acaba de ver seis coletas distintas.
      var meta = PRODUCT_META[v.handle] || {};
      return {
        titulo: v.product,
        url: absUrl(v.url),
        precio: formatPrice(v.priceCents, v.price),
        imagen: meta.photo || v.image || '',
        swatch: v.image || ''
      };
    });
    postJSON('/lead/result', {
      email: state.email,
      lead_id: state.leadId,
      analysis_id: state.analysisId,
      tone: rec.tone,
      confidence: rec.confidence,
      description: rec.description || '',
      goal: state.goal || '',
      tone_vibe: state.toneVibe || '',
      tf_session_id: tfSessionId(),
      alternatives: (alternatives || []).map(function (a) { return a.tone; }),
      products: products
    }).catch(function () { /* queda pendiente en el backend, no se pierde */ });
  }

  /** Valoración de la experiencia. Sin analysis_id no hay a qué unirla. */
  function postRating(comment) {
    if (!state.analysisId) return Promise.resolve(false);
    return postJSON('/rating', {
      analysis_id: state.analysisId,
      rating: state.rating,
      comment: comment || '',
      placement: PLACEMENT
    }).then(function () { return true; }).catch(function () { return false; });
  }

  /* ---------- Render ---------- */
  function el(tag, attrs, children) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === 'class') e.className = attrs[k];
      else if (k === 'html') e.innerHTML = attrs[k];
      else if (k === 'style') e.setAttribute('style', attrs[k]);
      else if (k.slice(0, 2) === 'on') e.addEventListener(k.slice(2).toLowerCase(), attrs[k]);
      else e.setAttribute(k, attrs[k]);
    }
    (children || []).forEach(function (c) { if (c != null) e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return e;
  }
  var SVG_CAMERA = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#E6248A" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3.5"/></svg>';
  var SVG_CHECK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var SVG_SHIELD = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#1E7A48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>';

  var mount = root.querySelector('.tf-mount');

  function render() {
    if (!mount) return;
    mount.innerHTML = '';
    if (!candidates.length) { mount.appendChild(el('div', { class: 'tf-error' }, ['No hay tonos disponibles en stock ahora mismo.'])); return; }
    if (state.step === 'howto') mount.appendChild(renderHowto());
    else if (state.step === 'upload') mount.appendChild(renderUpload());
    else if (state.step === 'ready') mount.appendChild(renderReady());
    else if (state.step === 'analyzing') mount.appendChild(renderAnalyzing());
    else if (state.step === 'gate') mount.appendChild(renderGate());
    else if (state.step === 'result') mount.appendChild(renderResult());
    else if (state.step === 'invalid') mount.appendChild(renderInvalid());
    else if (state.step === 'quickview') mount.appendChild(renderQuickView());
    if (state.error) mount.appendChild(el('div', { class: 'tf-error' }, [state.error]));
  }

  // Los dos grupos de ejemplos ("hazlo así" / "evita esto"). Vive aparte porque lo pintan DOS
  // pantallas: la de consejos obligatoria y la de foto no válida. Una sola copia de los textos.
  function howtoPanel() {
    var goodGrid = el('div', { class: 'tf-howto-grid' });
    [0, 2].forEach(function (i, n) {
      goodGrid.appendChild(el('div', { class: 'tf-howto-step' }, [refImageTile(REF_PHOTOS[i], i), el('div', { class: 'tf-howto-cap' }, [(n + 1) + '. ' + REF_CAPTIONS[i]])]));
    });
    var badGrid = el('div', { class: 'tf-howto-grid tf-howto-grid-bad' });
    BAD_PHOTOS.forEach(function (url, i) {
      badGrid.appendChild(el('div', { class: 'tf-howto-step' }, [refImageTile(url, i, true), el('div', { class: 'tf-howto-cap' }, [BAD_CAPTIONS[i]])]));
    });
    var goodStrip = howtoCarousel(goodGrid), badStrip = howtoCarousel(badGrid);
    var panel = el('div', { class: 'tf-howto-panel' }, [
      el('div', { class: 'tf-howto-sub' }, [el('div', { class: 'tf-howto-sub-t' }, ['✅ Hazlo así']), goodStrip]),
      el('div', { class: 'tf-howto-sub tf-howto-sub-bad' }, [el('div', { class: 'tf-howto-sub-t' }, ['❌ Evita esto']), badStrip])
    ]);
    // Las medidas de un nodo que aún no cuelga del documento son 0: las flechas se recalculan
    // cuando ya está dentro.
    panel.tfSync = function () { goodStrip.tfSync(); badStrip.tfSync(); };
    return panel;
  }

  // Pantalla de consejos OBLIGATORIA: es lo primero que ve la clienta al abrir el buscador.
  // Antes era un panel plegable dentro de la pantalla de subir y en móvil nacía cerrado, así que
  // la mayoría subía la foto sin haberlo visto — y la calidad de la foto es la primera causa de
  // un mal match. Aquí no se puede saltar: solo se cruza pulsando "Entiendo".
  function renderHowto() {
    var wrap = el('div', { class: 'tf-howto-screen' });
    wrap.appendChild(el('span', { class: 'tf-pill' }, [el('span', { class: 'tf-dot' }), 'Buscador de tono · IA']));
    wrap.appendChild(el('h2', { class: 'tf-h1', html: 'Encuentra tu <span class="tf-mag">tono perfecto</span> ✨' }));
    wrap.appendChild(el('p', { class: 'tf-lead' }, ['Todo depende de la foto. Mira estos ejemplos diez segundos y tu match sale bien a la primera.']));
    var panel = howtoPanel();
    wrap.appendChild(panel);
    var cta = el('button', { class: 'tf-btn tf-btn-primary', type: 'button' }, ['Entiendo, subir mi foto']);
    cta.addEventListener('click', function () { dl('tf_howto_ack', {}); setState({ step: 'upload' }); });
    wrap.appendChild(el('div', { class: 'tf-howto-cta' }, [cta]));
    setTimeout(function () { panel.tfSync(); }, 0);
    dl('tf_howto_view', { entry: state.howtoSeen ? 'repeat' : 'first' });
    state.howtoSeen = true;
    return wrap;
  }

  function renderUpload() {
    var wrap = el('div', { class: 'tf-row tf-upload' });
    var left = el('div', { class: 'tf-col' }, [
      el('span', { class: 'tf-pill' }, [el('span', { class: 'tf-dot' }), 'Buscador de tono · IA']),
      el('h2', { class: 'tf-h1', html: 'Sube tu <span class="tf-mag">foto</span>' }),
      el('p', { class: 'tf-lead' }, ['Sube hasta 3 fotos de tu pelo con buena luz natural y nuestra IA te dice cuál de nuestros tonos es tu match ideal. Sin adivinar.']),
      el('p', { class: 'tf-ai-note' }, ['✨ ' + AI_NOTE])
    ]);
    var input = el('input', { type: 'file', accept: 'image/*', multiple: 'multiple', class: 'tf-file', id: 'tf-file' });
    input.addEventListener('change', function (e) { loadFiles(e.target.files); });
    var drop = el('label', { class: 'tf-drop', for: 'tf-file' }, [
      el('div', { class: 'tf-drop-ic', html: SVG_CAMERA }),
      el('div', { class: 'tf-drop-t' }, ['Toca para subir tus fotos']),
      el('div', { class: 'tf-drop-s' }, ['o arrástralas y suéltalas aquí']),
      el('div', { class: 'tf-drop-h' }, ['Hasta 3 · JPG · PNG · HEIC — Máx 10 MB c/u'])
    ]);
    drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('tf-drag'); });
    drop.addEventListener('dragleave', function (e) { e.preventDefault(); drop.classList.remove('tf-drag'); });
    drop.addEventListener('drop', function (e) { e.preventDefault(); drop.classList.remove('tf-drag'); loadFiles(e.dataTransfer.files); });
    // El panel de ejemplos vive ahora en su propia pantalla (renderHowto), obligatoria antes de
    // subir. Aquí queda solo la puerta de vuelta, para quien quiera repasarlos.
    var howBtn = el('button', { class: 'tf-howto-btn', type: 'button' }, ['📸 Ver otra vez cómo tomarte las fotos']);
    howBtn.addEventListener('click', function () { dl('tf_howto_open', {}); setState({ step: 'howto' }); });
    var right = el('div', { class: 'tf-col' }, [input, drop, el('div', { class: 'tf-howto' }, [howBtn])]);
    wrap.appendChild(left); wrap.appendChild(right);
    return wrap;
  }

  function chip(label, active, onClick) {
    var b = el('button', { class: 'tf-chip' + (active ? ' tf-chip-on' : '') }, [label]);
    b.addEventListener('click', onClick); return b;
  }
  function renderReady() {
    var wrap = el('div', { class: 'tf-row tf-ready' });
    var left = el('div', { class: 'tf-col' });
    left.appendChild(el('span', { class: 'tf-pill' }, [el('span', { class: 'tf-dot' }), 'Casi listo']));
    left.appendChild(el('h2', { class: 'tf-h1', html: 'Afina tu <span class="tf-mag">match</span>' }));
    left.appendChild(el('div', { class: 'tf-label' }, ['¿Qué buscas? (opcional)']));
    var goals = el('div', { class: 'tf-chips' });
    ['Igualar mi color', 'Algo más claro', 'Algo más oscuro'].forEach(function (v) {
      goals.appendChild(chip(v, state.goal === v, function () { setState({ goal: state.goal === v ? '' : v }); }));
    });
    left.appendChild(goals);
    left.appendChild(el('div', { class: 'tf-label' }, ['¿Ponytail o extensiones? (opcional)']));
    var ptypes = el('div', { class: 'tf-chips' });
    ['Ponytail', 'Extensiones'].forEach(function (v) {
      ptypes.appendChild(chip(v, state.productType === v, function () { setState({ productType: state.productType === v ? '' : v }); }));
    });
    left.appendChild(ptypes);
    var consent = el('button', { class: 'tf-consent' }, [
      el('span', { class: 'tf-check' + (state.consent ? ' tf-check-on' : ''), html: SVG_CHECK }),
      el('span', { class: 'tf-consent-t' }, [CONSENT_TEXT])
    ]);
    consent.addEventListener('click', function () { setState({ consent: !state.consent }); });
    left.appendChild(consent);
    // El enlace va FUERA del botón: dentro sería HTML inválido y, peor, el clic
    // marcaría la casilla en vez de abrir la política.
    if (PRIVACY_URL) {
      var pnote = el('p', { class: 'tf-consent-note' }, []);
      var plink = el('a', { class: 'tf-consent-link' }, ['Política de tratamiento de datos']);
      plink.setAttribute('href', PRIVACY_URL);
      plink.setAttribute('target', '_blank');
      plink.setAttribute('rel', 'noopener');
      pnote.appendChild(plink);
      left.appendChild(pnote);
    }
    var canGo = state.consent && state.photos.length > 0;
    var btn = el('button', { class: 'tf-btn tf-btn-primary' + (canGo ? '' : ' tf-btn-disabled') }, ['Analizar mi color']);
    btn.disabled = !canGo;
    btn.addEventListener('click', prepare);
    left.appendChild(btn);

    // Galería de fotos (hasta 3) con quitar + añadir.
    var right = el('div', { class: 'tf-photo-card' });
    var grid = el('div', { class: 'tf-photo-grid' });
    state.photos.forEach(function (p, idx) {
      var thumb = el('div', { class: 'tf-photo-thumb' }, [el('img', { src: p.url, alt: 'Foto ' + (idx + 1) })]);
      var rm = el('button', { class: 'tf-photo-rm', 'aria-label': 'Quitar foto' }, ['×']);
      rm.addEventListener('click', function (e) { e.preventDefault(); removePhoto(idx); });
      thumb.appendChild(rm);
      grid.appendChild(thumb);
    });
    if (state.photos.length < MAX_PHOTOS) {
      var addTile = el('label', { class: 'tf-photo-add', for: 'tf-file-add' }, [el('span', { html: '＋' }), el('span', { class: 'tf-photo-add-t' }, ['Añadir foto'])]);
      grid.appendChild(addTile);
      var input2 = el('input', { type: 'file', accept: 'image/*', multiple: 'multiple', class: 'tf-file', id: 'tf-file-add' });
      input2.addEventListener('change', function (e) { loadFiles(e.target.files); });
      right.appendChild(input2);
    }
    right.appendChild(grid);
    right.appendChild(el('p', { class: 'tf-photo-hint' }, ['Puedes subir hasta 3 fotos (de frente, de lado, con buena luz) para afinar el resultado.']));
    wrap.appendChild(left); wrap.appendChild(right);
    return wrap;
  }

  function renderAnalyzing() {
    var wrap = el('div', { class: 'tf-analyzing' });
    var ph = el('div', { class: 'tf-scan' }, [el('img', { src: primaryUrl(), alt: '' }), el('div', { class: 'tf-shimmer' })]);
    // El encabezado cambia con el tramo: en el primero todavía no se está analizando nada,
    // y decir que sí sería mentirle a la clienta para que espere.
    var heading = state.phase === 'prep' ? 'Preparando tu foto' : 'Analizando tu color';
    var row = el('div', { class: 'tf-scan-row' }, [el('div', { class: 'tf-spin' }), el('span', { class: 'tf-scan-t' }, [heading])]);
    var fill = el('div', { class: 'tf-bar-fill', style: 'width:' + state.progress + '%' });
    var bar = el('div', { class: 'tf-bar' }, [fill]);
    var st = el('div', { class: 'tf-status' }, [state.statusText]);
    timers.barFill = fill; timers.statusEl = st;
    wrap.appendChild(ph); wrap.appendChild(row); wrap.appendChild(bar); wrap.appendChild(st);
    return wrap;
  }

  /* ---------- La puerta: nombre + correo + consentimiento ---------- */
  // Se pinta con la barra parada al 90%, encima de la misma foto que ya estaba en pantalla:
  // la clienta ve que su análisis está a un paso, no que la han mandado a otro sitio.
  function renderGate() {
    var wrap = el('div', { class: 'tf-analyzing tf-gate' });
    wrap.appendChild(el('div', { class: 'tf-scan tf-scan-done' }, [el('img', { src: primaryUrl(), alt: '' })]));
    var fill = el('div', { class: 'tf-bar-fill', style: 'width:' + GATE_AT + '%' });
    wrap.appendChild(el('div', { class: 'tf-bar' }, [fill]));

    wrap.appendChild(el('div', { class: 'tf-gate-t' }, ['Tu foto ya está lista ✨']));
    wrap.appendChild(el('p', { class: 'tf-gate-s' }, ['Déjanos tu nombre y correo: te damos tu tono y te lo enviamos por email.']));

    var nameEl = el('input', { type: 'text', class: 'tf-save-input tf-gate-input', placeholder: 'Tu nombre', autocomplete: 'given-name', value: state.gateName || '' });
    nameEl.addEventListener('input', function () { state.gateName = nameEl.value; }); // persiste entre re-renders
    var mailEl = el('input', { type: 'email', class: 'tf-save-input tf-gate-input', placeholder: 'tu@email.com', autocomplete: 'email', value: state.email || '' });
    mailEl.addEventListener('input', function () { state.email = mailEl.value; });
    wrap.appendChild(el('div', { class: 'tf-gate-fields' }, [nameEl, mailEl]));

    var consent = el('button', { class: 'tf-consent', type: 'button' }, [
      el('span', { class: 'tf-check' + (state.gateConsent ? ' tf-check-on' : ''), html: SVG_CHECK }),
      el('span', { class: 'tf-consent-t' }, [GATE_CONSENT_TEXT])
    ]);
    consent.addEventListener('click', function () {
      state.gateConsent = !state.gateConsent;
      // Repintado local: un setState global reconstruiría los inputs y perdería el foco
      // a media escritura, que en móvil equivale a cerrar el teclado en cada toque.
      consent.querySelector('.tf-check').className = 'tf-check' + (state.gateConsent ? ' tf-check-on' : '');
    });
    wrap.appendChild(consent);
    // El enlace va FUERA del botón: dentro sería HTML inválido y el clic marcaría la
    // casilla en vez de abrir la política.
    if (PRIVACY_URL) {
      var plink = el('a', { class: 'tf-consent-link' }, ['Política de tratamiento de datos']);
      plink.setAttribute('href', PRIVACY_URL);
      plink.setAttribute('target', '_blank');
      plink.setAttribute('rel', 'noopener');
      wrap.appendChild(el('p', { class: 'tf-consent-note' }, [plink]));
    }

    var statusEl = el('p', { class: 'tf-save-status' });
    var btn = el('button', { class: 'tf-btn tf-btn-primary', type: 'button' }, ['Ver mi tono ✨']);
    btn.addEventListener('click', function () { submitGate(statusEl, btn); });
    mailEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') btn.click(); });
    nameEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') mailEl.focus(); });
    wrap.appendChild(btn);
    wrap.appendChild(statusEl);
    return wrap;
  }

  function submitGate(statusEl, btn) {
    var email = (state.email || '').trim();
    var name = (state.gateName || '').trim();
    function fail(msg) { statusEl.textContent = msg; statusEl.className = 'tf-save-status tf-save-err'; }
    if (!name) return fail('Dinos cómo te llamas, porfa.');
    if (!EMAIL_RE.test(email)) return fail('Escribe un correo válido, porfa.');
    if (!state.gateConsent) return fail('Necesitamos que aceptes el tratamiento de datos para enviarte tu resultado.');

    state.email = email; state.gateName = name; state.emailCaptured = true;
    storeLead(email, name);
    if (btn) { btn.disabled = true; btn.textContent = 'Analizando…'; }
    dl('tf_gate_submit', {});
    postLead();                     // no se espera: el análisis arranca ya
    klaviyoIdentify(email, name);   // apoyo onsite; si falla, no pasa nada
    runAnalysis();
  }

  // Fila de estrellas de reseñas (Judge.me). null si el producto no tiene reseñas.
  function starRow(rating, count) {
    if (rating == null || !count) return null;
    var pct = Math.max(0, Math.min(100, (Number(rating) / 5) * 100));
    var stars = el('span', { class: 'tf-stars', 'aria-label': Number(rating).toFixed(1) + ' de 5' }, [
      el('span', { class: 'tf-stars-base' }, ['★★★★★']),
      el('span', { class: 'tf-stars-fill', style: 'width:' + pct + '%' }, ['★★★★★'])
    ]);
    return el('span', { class: 'tf-rating' }, [stars, el('span', { class: 'tf-rating-c' }, ['(' + count + ')'])]);
  }

  // El prefill lo montamos aquí. NO se reutiliza el ajuste global del tema (`social_whatsapp`):
  // arrastra un texto heredado del sitio viejo y el dominio anterior de la tienda. Si MDH pone su
  // propio ?text= en el ajuste, manda el suyo.
  function waHref(tone) {
    if (/[?&]text=/.test(WHATSAPP_URL)) return WHATSAPP_URL;
    var msg = 'Hola, vengo del Buscador de Tono. Mi resultado fue "' + (tone || '') + '" y tengo una duda.';
    return WHATSAPP_URL + (WHATSAPP_URL.indexOf('?') >= 0 ? '&' : '?') + 'text=' + encodeURIComponent(msg);
  }
  // Enlaces del aviso legal. Nodos DOM y setAttribute, nunca innerHTML: RESULT_DISCLAIMER es
  // texto que edita el comerciante desde el admin, y meterlo en un innerHTML junto a dos <a> es
  // una inyección esperando a ocurrir. Mismo patrón que el enlace de privacidad del consentimiento.
  function legalLink(href, label, onClick) {
    var a = el('a', { class: 'tf-result-link' }, [label]);
    a.setAttribute('href', href);
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener');
    if (onClick) a.addEventListener('click', onClick);
    return a;
  }

  function renderResult() {
    var rec = state.rec, wrap = el('div', { class: 'tf-result' });
    // La muestra grande es la MISMA foto de mecha que verá en la ficha, no un color plano: es lo
    // que de verdad le dice cómo va a quedar. Si el tono no tiene variante con foto, cae al hex.
    var recPhoto = toneSwatchPhoto(rec.tone);
    var recSwatch = recPhoto
      ? el('img', { class: 'tf-swatch-lg', src: recPhoto, alt: rec.tone, loading: 'lazy' })
      : el('div', { class: 'tf-swatch-lg', style: 'background:' + rec.hex });
    // tarjeta tono recomendado (sin indicador de confianza: se quitó el "98%")
    var head = el('div', { class: 'tf-rec-card' }, [
      el('div', { class: 'tf-rec-top' }, [
        recSwatch,
        el('div', { class: 'tf-rec-meta' }, [
          el('div', { class: 'tf-overline' }, ['Tu tono recomendado']),
          el('h2', { class: 'tf-h2' }, [rec.tone]),
          el('p', { class: 'tf-desc' }, [rec.description])
        ])
      ])
    ]);
    wrap.appendChild(head);
    // Aviso legal: el match lo hace una IA, puede equivocarse, y hay una persona detrás.
    // Mientras el sistema aprende, esta línea es lo que separa una recomendación de una promesa.
    var note = el('p', { class: 'tf-result-disclaimer' }, [RESULT_DISCLAIMER + ' ']);
    if (WHATSAPP_URL) {
      note.appendChild(legalLink(waHref(rec.tone), '¿Dudas? Escríbenos por WhatsApp', function () {
        dl('tf_whatsapp_click', { recommended_tone: rec.tone });
      }));
    }
    if (WHATSAPP_URL && TERMS_URL) note.appendChild(el('span', { class: 'tf-result-sep' }, [' · ']));
    if (TERMS_URL) note.appendChild(legalLink(TERMS_URL, 'Términos y condiciones'));
    wrap.appendChild(note);

    // Feedback de entrenamiento (bien/mal + formulario) — con ?tf_train=1 o el ajuste "Mostrar feedback".
    if (SHOW_FEEDBACK) wrap.appendChild(renderFeedback());

    // bloque "disponible en" (cambia según el tono mostrado: recomendado o alternativa)
    var listWrap = el('div', { class: 'tf-products' });
    wrap.appendChild(listWrap);
    renderProducts(listWrap, state.shownTone, false);

    // garantía
    wrap.appendChild(el('div', { class: 'tf-guarantee', html: SVG_SHIELD + '<strong>' + escapeHtml(GUARANTEE) + '</strong>' }));

    // alternativas como chips que intercambian la lista + su "porqué"
    if (SHOW_ALTS && state.alternatives.length) {
      var altBox = el('div', { class: 'tf-alts' });
      altBox.appendChild(el('div', { class: 'tf-alts-t' }, ['También podrían funcionarte']));
      altBox.appendChild(el('p', { class: 'tf-alts-s' }, ['Estos tonos son muy cercanos al tuyo. Toca uno para ver dónde comprarlo:']));
      // Solo las 2 alternativas (NO el tono principal).
      var chips = el('div', { class: 'tf-chips' });
      var altReason = el('p', { class: 'tf-alt-reason', style: 'display:none' });
      var backLink = el('button', { class: 'tf-alt-back', type: 'button' }, ['↩ Ver tu tono recomendado (' + rec.tone + ')']);
      function showReason(toneName) {
        var found = (state.alternatives || []).find(function (a) { return a.tone === toneName; });
        if (found && found.reason) { altReason.textContent = found.reason; altReason.style.display = ''; }
        else { altReason.textContent = ''; altReason.style.display = 'none'; }
      }
      function backToPrimary() {
        state.shownTone = rec.tone;
        mount.querySelectorAll('.tf-tone-chip').forEach(function (x) { x.classList.remove('tf-chip-on'); });
        renderProducts(listWrap, rec.tone, false);
        showReason(rec.tone);
        backLink.style.display = 'none';
        dl('tf_alt_view', { tone: rec.tone });
      }
      backLink.addEventListener('click', backToPrimary);
      state.alternatives.forEach(function (t) {
        var c = el('button', { class: 'tf-tone-chip' + (t.tone === state.shownTone ? ' tf-chip-on' : '') }, [
          el('span', { class: 'tf-swatch-sm', style: 'background:' + t.hex }), t.tone
        ]);
        c.addEventListener('click', function () {
          state.shownTone = t.tone;
          mount.querySelectorAll('.tf-tone-chip').forEach(function (x) { x.classList.remove('tf-chip-on'); });
          c.classList.add('tf-chip-on');
          renderProducts(listWrap, t.tone, false);
          showReason(t.tone);
          backLink.style.display = '';
          dl('tf_alt_view', { tone: t.tone });
        });
        chips.appendChild(c);
      });
      altBox.appendChild(chips);
      altBox.appendChild(altReason);
      altBox.appendChild(backLink);
      // Estado inicial coherente si volvemos de la vista rápida con una alternativa activa.
      backLink.style.display = (state.shownTone && state.shownTone !== rec.tone) ? '' : 'none';
      showReason(state.shownTone);
      wrap.appendChild(altBox);
    }

    // Valoración de la experiencia. Solo si hay analysis_id: sin él no habría a qué unirla,
    // y pintar unos botones que no guardan nada sería pedirle su opinión para tirarla.
    if (SHOW_RATING && state.analysisId) wrap.appendChild(renderClientRating());

    var reset = el('button', { class: 'tf-reset' }, ['Probar con otra foto']);
    reset.addEventListener('click', doReset);
    wrap.appendChild(el('div', { class: 'tf-center' }, [reset]));
    return wrap;
  }

  /* ---------- Valoración de la clienta (👎 / 👍 / 😍) ---------- */
  // OJO: no es el 👍/👎 de renderFeedback. Aquel es entrenamiento, lo pulsa una asesora en
  // modo ?tf_train=1 y sube la foto a un Sheet. Esto lo pulsa la clienta real, pregunta por
  // la EXPERIENCIA y no manda ninguna imagen a ninguna parte.
  //
  // El emoji se envía en cuanto se pulsa, sin esperar al comentario: la mayoría no escribirá
  // nada, y condicionar la valoración a rellenar un texto es perderla. Si luego escribe, se
  // manda otra vez — el backend guarda «la última gana» justamente para esto.
  var RATING_OPTS = [
    { key: 'dislike', emoji: '👎', label: 'No me convenció' },
    { key: 'like', emoji: '👍', label: 'Está bien' },
    { key: 'love', emoji: '😍', label: '¡Me encantó!' }
  ];
  function renderClientRating() {
    var box = el('div', { class: 'tf-vote' });

    function paintComment() {
      var det = el('details', { class: 'tf-vote-more' });
      det.appendChild(el('summary', { class: 'tf-vote-sum' }, ['Cuéntanos por qué (opcional)']));
      var ta = el('textarea', { class: 'tf-save-input tf-vote-ta', rows: '3', placeholder: 'Lo que quieras contarnos: qué te gustó, qué mejorarías…' });
      var status = el('p', { class: 'tf-save-status' });
      var send = el('button', { class: 'tf-btn tf-btn-primary tf-btn-sm', type: 'button' }, ['Enviar comentario']);
      send.addEventListener('click', function () {
        var txt = (ta.value || '').trim();
        if (!txt) { status.textContent = 'Escribe algo primero 🙂'; status.className = 'tf-save-status tf-save-err'; return; }
        send.disabled = true; send.textContent = 'Enviando…';
        postRating(txt).then(function (ok) {
          if (ok) {
            dl('tf_rating', { rating: state.rating, has_comment: true, recommended_tone: (state.rec || {}).tone });
            // Se sustituye el <details> entero, no su contenido: vaciarlo se llevaba por
            // delante el propio <summary> y el navegador pintaba su etiqueta por defecto
            // («Details», en inglés) sobre un desplegable que ya no desplegaba nada.
            det.parentNode.replaceChild(el('p', { class: 'tf-vote-thanks' }, ['¡Gracias! Lo leemos todo 💌']), det);
          } else {
            send.disabled = false; send.textContent = 'Enviar comentario';
            status.textContent = 'No pudimos enviarlo. Revisa la conexión e inténtalo de nuevo.';
            status.className = 'tf-save-status tf-save-err';
          }
        });
      });
      det.appendChild(ta); det.appendChild(send); det.appendChild(status);
      return det;
    }

    function paint() {
      box.innerHTML = '';
      box.appendChild(el('div', { class: 'tf-vote-q' }, ['¿Qué te pareció tu match?']));
      var btns = el('div', { class: 'tf-vote-btns' });
      RATING_OPTS.forEach(function (o) {
        var b = el('button', { class: 'tf-vote-btn' + (state.rating === o.key ? ' tf-vote-on' : ''), type: 'button', 'aria-label': o.label }, [
          el('span', { class: 'tf-vote-emoji' }, [o.emoji]),
          el('span', { class: 'tf-vote-label' }, [o.label])
        ]);
        b.addEventListener('click', function () {
          state.rating = o.key;
          state.ratingSent = o.key;
          // Optimista: se repinta ya y el envío va detrás. Si falla, no se le dice nada —
          // no hay nada que la clienta pueda hacer al respecto y ya nos dio su opinión.
          paint();
          postRating('');
          dl('tf_rating', { rating: o.key, has_comment: false, recommended_tone: (state.rec || {}).tone });
        });
        btns.appendChild(b);
      });
      box.appendChild(btns);
      if (state.ratingSent) {
        box.appendChild(el('p', { class: 'tf-vote-thanks' }, ['¡Gracias! Nos ayuda a mejorar 💌']));
        box.appendChild(paintComment());
      }
    }

    paint();
    return box;
  }

  /* ---------- Feedback de entrenamiento (bien/mal → backend → Google Sheet) ---------- */
  // Se muestra solo en modo entrenamiento (TRAIN). El bloque se auto-repinta sin re-render global
  // para no reconstruir toda la tarjeta de resultado (mismo patrón que las chips de alternativas).
  function renderFeedback() {
    var box = el('div', { class: 'tf-feedback' });

    function buildPayload(extra) {
      var rec = state.rec || {};
      return {
        verdict: state.feedbackVerdict,
        recommended: rec.tone || '',
        alternatives: (state.alternatives || []).map(function (a) { return a.tone; }),
        correctTone: (extra && extra.correctTone) || '',
        comment: (extra && extra.comment) || '',
        goal: state.goal || '',
        highlights: state.highlights || '',
        toneVibe: state.toneVibe || '',
        confidence: rec.confidence,
        placement: PLACEMENT,
        analysis_id: state.analysisId || '',
        visualFeatures: state.prepared && state.prepared.visualFeatures
          ? state.prepared.visualFeatures
          : null
      };
    }
    // Envía el feedback con la(s) foto(s) en base64 (se regeneran desde state.photos, aún presentes).
    function postFeedback(payload) {
      if (!BACKEND) return Promise.reject(new Error('sin URL de backend en los ajustes del tema'));
      return toBase64All().then(function (imgs) {
        payload.images = imgs;
        var ctrl = new AbortController();
        var to = setTimeout(function () { ctrl.abort(); }, 15000);
        return fetch(BACKEND + '/feedback', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: ctrl.signal
        }).then(function (r) {
          clearTimeout(to);
          if (!r.ok) throw new Error('http ' + r.status);
          return r.json();
        }, function (e) {
          clearTimeout(to);
          throw new Error(e && e.name === 'AbortError' ? 'sin respuesta (timeout)' : 'no se pudo conectar con el backend');
        });
      });
    }

    function renderForm() {
      var form = el('div', { class: 'tf-feedback-form' });
      form.appendChild(el('div', { class: 'tf-label' }, ['¿Cuál debía ser el tono? (opcional)']));
      var sel = el('select', { class: 'tf-save-input tf-feedback-select' });
      sel.appendChild(el('option', { value: '' }, ['— Selecciona un tono —']));
      candidates.forEach(function (c) { sel.appendChild(el('option', { value: c.tone }, [c.tone])); });
      form.appendChild(sel);
      form.appendChild(el('div', { class: 'tf-label' }, ['¿Cómo mejorar la recomendación?']));
      var ta = el('textarea', { class: 'tf-save-input tf-feedback-ta', rows: '3', placeholder: 'Ej: la base es más rojiza; debería recomendar Caoba en vez de Castaño Medio…' });
      form.appendChild(ta);
      var status = el('p', { class: 'tf-save-status' });
      var send = el('button', { class: 'tf-btn tf-btn-primary tf-btn-sm', type: 'button' }, ['Enviar feedback']);
      send.addEventListener('click', function () {
        send.disabled = true; send.textContent = 'Enviando…';
        var payload = buildPayload({ correctTone: sel.value, comment: (ta.value || '').trim() });
        postFeedback(payload).then(function () {
          dl('tf_feedback', { verdict: 'mal', recommended_tone: payload.recommended, correct_tone: payload.correctTone });
          state.feedbackSent = true; paint();
        }).catch(function (err) {
          send.disabled = false; send.textContent = 'Enviar feedback';
          status.textContent = 'No pudimos enviar el feedback. Revisa la conexión e inténtalo de nuevo.' + (SHOW_FEEDBACK ? ' [' + ((err && err.message) || 'error') + ']' : '');
          status.className = 'tf-save-status tf-save-err';
          if (SHOW_FEEDBACK && window.console && console.error) console.error('[tf feedback] fallo al enviar:', err, '· backend:', BACKEND || '(vacío)');
        });
      });
      form.appendChild(send); form.appendChild(status);
      return form;
    }

    function paint() {
      box.innerHTML = '';
      if (state.feedbackSent) {
        box.appendChild(el('div', { class: 'tf-feedback-thanks' }, ['¡Gracias! Tu feedback nos ayuda a entrenar la IA 💌']));
        return;
      }
      box.appendChild(el('div', { class: 'tf-feedback-q' }, [
        el('span', { class: 'tf-feedback-tag' }, ['🧪 Entrenamiento']),
        '¿La recomendación fue acertada?'
      ]));
      var btns = el('div', { class: 'tf-feedback-btns' });
      var yes = el('button', { class: 'tf-feedback-btn' + (state.feedbackVerdict === 'bien' ? ' tf-feedback-on' : ''), type: 'button' }, ['👍 Bien']);
      yes.addEventListener('click', function () {
        state.feedbackVerdict = 'bien';
        // Optimista: la valoración positiva no lleva texto que perder; enviamos best-effort.
        state.feedbackSent = true; paint();
        dl('tf_feedback', { verdict: 'bien', recommended_tone: (state.rec || {}).tone });
        postFeedback(buildPayload({})).catch(function () { /* best-effort */ });
      });
      var no = el('button', { class: 'tf-feedback-btn' + (state.feedbackVerdict === 'mal' ? ' tf-feedback-on' : ''), type: 'button' }, ['👎 Mal']);
      no.addEventListener('click', function () { state.feedbackVerdict = 'mal'; paint(); });
      btns.appendChild(yes); btns.appendChild(no);
      box.appendChild(btns);
      if (state.feedbackVerdict === 'mal') box.appendChild(renderForm());
    }

    paint();
    return box;
  }

  function renderProducts(container, toneName, expanded) {
    container.innerHTML = '';
    // PDP: atajo directo — si este producto tiene el tono, se marca en el selector y se cierra el buscador.
    // Va dentro de renderProducts para que se refresque solo al cambiar entre tono recomendado y alternativas.
    var pdpVariant = pdpVariantForTone(toneName);
    if (pdpVariant) {
      var useHere = el('button', { class: 'tf-btn tf-btn-primary tf-pdp-pick', type: 'button' }, ['Elegir este tono aquí']);
      useHere.addEventListener('click', function () {
        dl('tf_cta_click', { recommended_tone: toneName, variant_id: pdpVariant.id, cta_type: 'pdp_select' });
        selectToneOnPdp(toneName);
        doClose();
      });
      container.appendChild(useHere);
      container.appendChild(el('p', { class: 'tf-pdp-pick-note' }, ['Lo dejamos seleccionado en esta ficha, listo para añadir al carrito.']));
    }
    var variants = availableForTone(toneName);
    // Filtro por tipo de producto elegido en la pantalla de ajuste (Ponytail / Extensiones). Solo afecta a la lista mostrada.
    if (state.productType) variants = variants.filter(function (v) { return v.type === state.productType; });
    var hex = toneByName[toneName] ? toneByName[toneName].hex : '#ccc';
    if (variants.length) container.appendChild(el('div', { class: 'tf-products-t' }, ['Disponible en ' + variants.length + (variants.length === 1 ? ' producto' : ' productos')]));
    var show = expanded ? variants : variants.slice(0, PRODUCTS_LIMIT);
    show.forEach(function (v) {
      var card = el('div', { class: 'tf-prod' });
      // Zona clicable (imagen + info) que abre la VISTA RÁPIDA dentro del modal.
      var link = el('button', { class: 'tf-prod-link', type: 'button' });
      link.addEventListener('click', function () { openQuickView(v); });
      // Foto de MODELO del producto (no el swatch del tono) + descripción, para distinguir cuál es cuál.
      var meta = PRODUCT_META[v.handle] || {};
      var rowImg = meta.photo || v.image;
      if (rowImg) link.appendChild(el('img', { class: 'tf-prod-img', src: rowImg, alt: v.product, loading: 'lazy' }));
      else link.appendChild(el('span', { class: 'tf-swatch-sm', style: 'background:' + hex }));
      var infoKids = [el('span', { class: 'tf-prod-name' }, [v.product])];
      if (meta.desc) {
        var descEl = el('span', { class: 'tf-prod-desc' }, [meta.desc]);
        infoKids.push(descEl);
        // "Leer más" solo si de verdad hay más que las 2 líneas visibles. Es un span (no <button>) con
        // stopPropagation para expandir sin abrir la vista rápida (vive dentro del .tf-prod-link clicable).
        if (meta.desc.length > 90) {
          var moreBtn = el('span', { class: 'tf-prod-desc-more', role: 'button', tabindex: '0' }, ['Leer más']);
          var toggleDesc = function (e) {
            if (e) { e.preventDefault(); e.stopPropagation(); }
            var open = descEl.classList.toggle('tf-prod-desc--open');
            moreBtn.textContent = open ? 'Leer menos' : 'Leer más';
          };
          moreBtn.addEventListener('click', toggleDesc);
          moreBtn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') toggleDesc(e); });
          infoKids.push(moreBtn);
        }
      }
      infoKids.push((v.priceCents != null || v.price) ? el('span', { class: 'tf-prod-price' }, [formatPrice(v.priceCents, v.price)]) : null);
      infoKids.push(starRow(v.rating, v.ratingCount));
      infoKids.push(el('span', { class: 'tf-prod-sub' }, [(v.type || '') + (v.qty != null ? ' · ' + v.qty + ' en stock' : '')]));
      link.appendChild(el('div', { class: 'tf-prod-info' }, infoKids));
      card.appendChild(link);
      var add = el('button', { class: 'tf-btn tf-btn-primary tf-btn-sm' }, ['Añadir a mi carrito']);
      add.addEventListener('click', function () { dl('tf_cta_click', { recommended_tone: toneName, variant_id: v.id, cta_type: 'add' }); addToCart(v, add); });
      card.appendChild(add);
      container.appendChild(card);
    });
    if (!variants.length) {
      var emptyMsg = state.productType
        ? 'No hay ' + state.productType.toLowerCase() + ' en este tono. Prueba una alternativa o quita el filtro de arriba.'
        : 'Por ahora este tono está agotado. Prueba con una alternativa.';
      container.appendChild(el('p', { class: 'tf-desc' }, [emptyMsg]));
    } else if (!expanded && variants.length > PRODUCTS_LIMIT) {
      var more = el('button', { class: 'tf-more' }, ['Ver ' + (variants.length - PRODUCTS_LIMIT) + ' productos más']);
      more.addEventListener('click', function () { dl('tf_view_more', { tone: toneName, total: variants.length }); renderProducts(container, toneName, true); });
      container.appendChild(more);
    }
  }

  /* ---------- Vista rápida de producto (dentro del modal) ---------- */
  // El tema agrupa imágenes por color con la convención de alt "#color_<Valor>"; las de modelo/detalle/empaque
  // no llevan "#color_". Replicamos ese filtrado para mostrar SOLO las del tono elegido + las compartidas.
  function mediaSrc(m) { return (m && (m.src || (m.preview_image && m.preview_image.src))) || ''; }
  function colorFromAlt(alt) {
    if (!alt) return null;
    var i = String(alt).toLowerCase().indexOf('#color_');
    return i < 0 ? null : String(alt).slice(i + 7).trim().toLowerCase();
  }
  function mediaForVariant(p, variantId) {
    var media = (p && p.media) || [];
    var variant = ((p && p.variants) || []).filter(function (v) { return v.id === variantId; })[0];
    var color = variant && variant.featured_media ? colorFromAlt(variant.featured_media.alt) : null;
    if (!media.length) return (p.images || []).slice();
    var picked = media.filter(function (m) {
      var c = colorFromAlt(m.alt);
      if (c === null) return true;           // modelo/detalle/empaque → siempre
      return color ? c === color : true;     // swatch/fotos del color seleccionado
    }).map(mediaSrc).filter(Boolean);
    // La imagen destacada del color va primero.
    if (variant && variant.featured_media) {
      var f = mediaSrc(variant.featured_media);
      if (f) picked = [f].concat(picked.filter(function (s) { return s !== f; }));
    }
    return picked.length ? picked : (p.images || []).slice();
  }
  function openQuickView(v) {
    state.quickProduct = { loading: true, fallback: v, data: null, variantId: v.id };
    setState({ step: 'quickview' });
    dl('tf_quickview_open', { handle: v.handle, variant_id: v.id });
    fetch('/products/' + v.handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      state.quickProduct = { loading: false, fallback: v, data: p, variantId: v.id };
      if (state.step === 'quickview') setState({});
    }).catch(function () {
      state.quickProduct = { loading: false, fallback: v, data: null, variantId: v.id };
      if (state.step === 'quickview') setState({});
    });
  }
  function renderQuickView() {
    var q = state.quickProduct || {};
    var wrap = el('div', { class: 'tf-quick' });
    var back = el('button', { class: 'tf-quick-back' }, ['← Volver a mi análisis']);
    back.addEventListener('click', function () { setState({ step: 'result', quickProduct: null }); });
    wrap.appendChild(back);

    if (q.loading) { wrap.appendChild(el('div', { class: 'tf-quick-loading' }, [el('div', { class: 'tf-spin' })])); return wrap; }
    var p = q.data;
    if (!p) {
      // sin datos → fallback al enlace clásico
      wrap.appendChild(el('p', { class: 'tf-desc' }, ['No pudimos cargar la vista rápida.']));
      wrap.appendChild(el('a', { class: 'tf-view', href: q.fallback.url, target: '_top' }, ['Ver ficha completa →']));
      return wrap;
    }
    var variants = p.variants || [];
    var selVariants = variants.filter(function (vv) { return !isPlaceholder(vv.title); }); // sin la variante "Elige tu tono"
    var selected = variants.filter(function (vv) { return vv.id === q.variantId; })[0] || selVariants[0] || variants[0] || {};

    var gallery = el('div', { class: 'tf-quick-gallery' });
    var mainImg = el('img', { class: 'tf-quick-main', alt: p.title });
    var thumbs = el('div', { class: 'tf-quick-thumbs' });
    gallery.appendChild(mainImg); gallery.appendChild(thumbs);
    function setGallery(imgs) {
      if (!imgs || !imgs.length) imgs = (p.images || []).slice(0, 1);
      mainImg.src = imgs[0] || '';
      thumbs.innerHTML = '';
      if (imgs.length > 1) imgs.slice(0, 6).forEach(function (src) {
        var th = el('img', { class: 'tf-quick-th', src: src, alt: '', loading: 'lazy' });
        th.addEventListener('click', function () { mainImg.src = src; });
        thumbs.appendChild(th);
      });
    }
    setGallery(mediaForVariant(p, selected.id));

    var info = el('div', { class: 'tf-quick-info' });
    info.appendChild(el('h2', { class: 'tf-h2' }, [p.title]));
    var priceEl = el('div', { class: 'tf-quick-price' }, [formatPrice(selected.price != null ? selected.price : p.price)]);
    info.appendChild(priceEl);
    if (p.description) info.appendChild(el('p', { class: 'tf-desc' }, [stripHtml(p.description).slice(0, 180) + (stripHtml(p.description).length > 180 ? '…' : '')]));

    var addBtn = el('button', { class: 'tf-btn tf-btn-primary' }, ['Añadir a mi carrito']);
    if (selVariants.length > 1) {
      var sel = el('select', { class: 'tf-quick-variant' });
      selVariants.forEach(function (vv) {
        var o = el('option', { value: String(vv.id) }, [vv.title + (vv.available ? '' : ' (agotado)')]);
        if (!vv.available) o.disabled = true;
        if (vv.id === selected.id) o.selected = 'selected';
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () {
        var vv = variants.filter(function (x) { return String(x.id) === sel.value; })[0];
        if (vv) { priceEl.textContent = formatPrice(vv.price); setGallery(mediaForVariant(p, vv.id)); }
      });
      info.appendChild(el('div', { class: 'tf-label' }, ['Elige tu tono / medida']));
      info.appendChild(sel);
      addBtn.addEventListener('click', function () {
        var id = Number(sel.value) || selected.id;
        dl('tf_cta_click', { recommended_tone: state.rec && state.rec.tone, variant_id: id, cta_type: 'add_quickview' });
        addToCart({ id: id, product: p.title }, addBtn);
      });
    } else {
      // Una sola variante real: usar esa (no la placeholder); si está agotada, deshabilitar.
      var only = selVariants[0] || selected;
      if (only && only.available === false) { addBtn.disabled = true; addBtn.textContent = 'Agotado'; addBtn.classList.add('tf-btn-disabled'); }
      addBtn.addEventListener('click', function () {
        dl('tf_cta_click', { recommended_tone: state.rec && state.rec.tone, variant_id: only.id, cta_type: 'add_quickview' });
        addToCart({ id: only.id, product: p.title }, addBtn);
      });
    }
    info.appendChild(addBtn);
    info.appendChild(el('a', { class: 'tf-view tf-quick-full', href: q.fallback.url, target: '_top' }, ['Ver ficha completa →']));

    var grid = el('div', { class: 'tf-quick-grid' }, [gallery, info]);
    wrap.appendChild(grid);
    return wrap;
  }

  // Carrusel de una fila para los grupos del panel "cómo tomarte las fotos": scroll nativo
  // (dedo en móvil) + flechas para el ratón, que se ocultan cuando no hay a dónde desplazarse.
  function howtoCarousel(track) {
    var prev = el('button', { class: 'tf-howto-arrow tf-howto-arrow-prev', type: 'button', 'aria-label': 'Ver ejemplos anteriores' }, ['‹']);
    var next = el('button', { class: 'tf-howto-arrow tf-howto-arrow-next', type: 'button', 'aria-label': 'Ver más ejemplos' }, ['›']);
    var strip = el('div', { class: 'tf-howto-carousel' }, [track, prev, next]);
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      strip.classList.toggle('tf-howto-scrollable', max > 4);
      prev.classList.toggle('tf-howto-arrow-off', track.scrollLeft <= 4);
      next.classList.toggle('tf-howto-arrow-off', track.scrollLeft >= max - 4);
    }
    function move(dir) {
      var s = track.querySelector('.tf-howto-step');
      var w = s ? s.getBoundingClientRect().width + 10 : 160;
      try { track.scrollBy({ left: dir * w, behavior: 'smooth' }); }
      catch (e) { track.scrollLeft += dir * w; } // navegadores sin scrollBy con opciones
    }
    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', sync);
    window.addEventListener('resize', sync);
    setTimeout(sync, 0);
    strip.tfSync = sync;
    return strip;
  }
  // bad = ejemplo en negativo ("evita esto"): marco rojo + aspa (CSS) y texto alternativo acorde.
  function refImageTile(url, idx, bad) {
    var cls = 'tf-ref-thumb' + (bad ? ' tf-ref-bad' : '');
    var alt = bad ? 'Ejemplo de foto que no funciona ' + (idx + 1) : 'Ejemplo de buena foto ' + (idx + 1);
    if (url) return el('div', { class: cls }, [el('img', { src: url, alt: alt, loading: 'lazy' })]);
    return el('div', { class: cls + ' tf-ref-empty' }, [el('span', { html: SVG_CAMERA })]);
  }
  function renderInvalid() {
    var wrap = el('div', { class: 'tf-invalid' });
    wrap.appendChild(el('div', { class: 'tf-invalid-ic', html: SVG_CAMERA }));
    wrap.appendChild(el('h2', { class: 'tf-h2' }, ['No pudimos leer bien tu tono 🙈']));
    wrap.appendChild(el('p', { class: 'tf-lead', style: 'margin:0 auto 20px;' }, ['No reconocimos bien tu cabello (puede ser por una foto poco clara, oscura o que no muestra el pelo). Para que la IA acierte, prueba con una foto así:']));
    // Los mismos seis ejemplos de la pantalla de consejos, no una copia con otros textos: esta
    // pantalla ES la de consejos, solo que llegando por el camino malo. Por eso «Subir otra foto»
    // va directo a subir y no la obliga a pasar otra vez por los consejos.
    wrap.appendChild(howtoPanel());
    var btn = el('button', { class: 'tf-btn tf-btn-primary', style: 'width:auto;' }, ['Subir otra foto']);
    btn.addEventListener('click', doReset);
    wrap.appendChild(el('div', { class: 'tf-center' }, [btn]));
    return wrap;
  }

  /* ---------- helpers de estado/archivo ---------- */
  function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function setState(patch) { for (var k in patch) state[k] = patch[k]; render(); }
  function stopTimers() { clearInterval(timers.prog); clearInterval(timers.stat); if (timers.abort) { try { timers.abort.abort(); } catch (e) {} timers.abort = null; } }
  function loadFiles(fileList) {
    if (!fileList || !fileList.length) return;
    var arr = Array.prototype.slice.call(fileList);
    var added = false, tooBig = false, dropped = 0;
    arr.forEach(function (file) {
      if (state.photos.length >= MAX_PHOTOS) { dropped++; return; }
      if (file.size > 10 * 1024 * 1024) { tooBig = true; return; }
      state.photos.push({ url: URL.createObjectURL(file), file: file });
      added = true;
    });
    if (added) {
      var msg = '';
      if (tooBig) msg = 'Alguna foto supera 10 MB y no se añadió.';
      else if (dropped > 0) msg = 'Solo se añadieron fotos hasta el máximo de ' + MAX_PHOTOS + '.';
      setState({ step: 'ready', error: msg });
      dl('tf_upload', { file_ok: true, count: state.photos.length });
    } else if (tooBig) {
      setState({ error: 'Esa foto pesa más de 10 MB. Prueba con una más ligera.' });
    } else if (state.photos.length >= MAX_PHOTOS) {
      setState({ error: 'Máximo ' + MAX_PHOTOS + ' fotos.' });
    }
  }
  function removePhoto(idx) {
    var p = state.photos[idx];
    if (p && p.url) URL.revokeObjectURL(p.url);
    state.photos.splice(idx, 1);
    setState({ step: state.photos.length ? 'ready' : 'upload', error: '' });
  }
  function doReset() {
    stopTimers(); sessionId++;
    state.photos.forEach(function (p) { if (p.url) URL.revokeObjectURL(p.url); });
    // OJO con lo que NO se limpia: email, gateName, gateConsent, emailCaptured y leadId.
    // Ya pagó el peaje. Volver a pedírselo por intentar con otra foto —el caso típico
    // después de una foto no válida— sería cobrarle dos veces por lo mismo.
    setState({
      step: 'upload', photos: [], consent: false, goal: '', highlights: '', toneVibe: '', productType: '',
      progress: 0, phase: '', rec: null, alternatives: [], shownTone: null, quickProduct: null,
      prepared: null, analysisId: '', rating: '', ratingSent: '',
      error: '', pdpSelected: '', feedbackVerdict: '', feedbackSent: false
    });
  }

  /* ---------- Modal vs inline ---------- */
  // Portal: saca el overlay del stacking context de product-info (PDP) moviéndolo a <body>.
  function portalOverlay() {
    var ov = root.querySelector('.tf-overlay') || document.querySelector('.tf-overlay');
    if (ov && ov.parentElement !== document.body) document.body.appendChild(ov);
    return ov;
  }
  function open() {
    portalOverlay();
    document.documentElement.classList.add('tf-modal-open', 'tf-no-scroll');
    dl('tf_open', {}); render();
  }
  function doClose() {
    // Si se cierra a media faena (preparando, esperando el correo o analizando): parar
    // timers, abortar e invalidar la sesión, para que al reabrir el estado sea estable.
    if (state.step === 'analyzing' || state.step === 'gate') {
      stopTimers(); sessionId++;
      setState({ step: state.photos.length ? 'ready' : 'upload', progress: 0, phase: '', prepared: null });
    }
    // PDP: al cerrar con un resultado en pantalla, dejamos el tono ya marcado en el selector de la ficha.
    if (state.rec && state.shownTone && state.pdpSelected !== state.shownTone) selectToneOnPdp(state.shownTone);
    document.documentElement.classList.remove('tf-modal-open', 'tf-no-scroll');
  }
  // Antes había un panel de «¿cerrar sin guardar?» que ofrecía dejar el correo al salir.
  // Con la puerta, el correo ya está capturado antes de que exista un resultado que perder,
  // así que ese panel no tenía nada que ofrecer y se ha quitado.
  function requestClose() { doClose(); }

  if (cfg.layout === 'modal') {
    // Delegación en document: los disparadores pueden estar FUERA de #tf-root (el botón «Encuentra tu tono
    // con IA» de la ficha de producto, uno para móvil y otro para PC) y el tema los vuelve a pintar en cada
    // cambio de variante (<product-rerender>), así que un listener directo se perdería.
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('.tf-trigger') : null;
      if (!t) return;
      e.preventDefault();
      open();
    });
    var closeBtn = root.querySelector('.tf-close');
    if (closeBtn) closeBtn.addEventListener('click', requestClose);
    var overlay = root.querySelector('.tf-overlay');
    if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) requestClose(); });
    render();
  } else {
    dl('tf_open', {});
    render();
  }

  // Aviso si no hay tonos con stock (caso límite)
  if (!candidates.length && mount) {
    mount.innerHTML = '<div class="tf-error">No hay tonos disponibles en stock ahora mismo.</div>';
  }
})();
